import {Box, Tooltip} from "@chakra-ui/react"

export default function Pressable(
    {label, isDisabled = false, onClick = () => {}, ...props})
{
    return (
        <Tooltip label={label}>
            <Box cursor={isDisabled ? 'not-allowed' : 'pointer'} __css={{transition: 'all 300ms'}}
                 style={isDisabled ? {opacity: 0.5} : null} _hover={isDisabled ? null : {opacity: 0.5}}
                 _active={isDisabled ? null : {opacity: 1, transform: 'scale(0.99)'}}
                 onClick={isDisabled ? null : onClick} {...props} />
        </Tooltip>
    )
}